import axios from 'axios';

const userApi = axios.create({
  baseURL: process.env.REACT_APP_USER_API_URL,
});

export default userApi;
